import { render } from "./DateField.vue?vue&type=template&id=88d20c72"
import script from "./DateField.vue?vue&type=script&lang=js"
export * from "./DateField.vue?vue&type=script&lang=js"
script.render = render

export default script